import { repository } from 'src/jtech/jtech-repository'
import { JtechAxios } from 'src/plugins/axios'

export const IntegrationLatisRepository = {
  nmInterfaceGenerateLatis: 'integrationLatis.generateLatis',
  nmInterfaceLatisDispatchList: 'latisDispatch.pesquisarFile',
  nmInterfaceSendLatis: 'integrationLatis.sendLatis',
  nmInterfaceProcess: 'samae.importFile',
  nmInterfaceGerarDocumento: 'samae.gerarDocumento',
  nmInterfaceFinancialProcess: 'samae.startFinancialProcess',
  nmInterfaceExport: 'samae.exportFile',
  nmInterfaceJoinUnit: 'samae.joinUnit',
  nmInterfaceVerificaFileSamaeFinalizado: 'samae.verificaFileSamaeFinalizado',
  nmInterfaceUnitStateSamae: 'samae.unitStateSamae',
  nmInterfaceUnitStateSamaeDetalhar: 'samae.unitStateSamaeDetalhar',
  nmInterfaceAnalyze: 'samae.analyze',
  nmInterfaceStateSamaePesquisar: 'stateSamae.pesquisar',
  nmInterfaceUnitStateSamaeUnitDisabled: 'samae.unitStateSamaeUnitDisabled',
  nmInterfaceUnitStateSamaeClientChange: 'samae.unitStateSamaeClientChange',
  nmInterfaceUnitStateSamaeUnitNew: 'samae.unitStateSamaeUnitNew',
  nmInterfaceUnitStateSamaeUnitNewAssociate: 'samae.unitStateSamaeUnitNewAssociate',
  nmInterfaceFindConsumerUnitByConvag: 'consumerUnit.findConsumerUnitByCompanyCodeWater',
  nmInterfaceAlterPaymentType: 'consumerUnit.alterPaymentType',

  generateLatis: async function () {
    return await repository.resolve(this.nmInterfaceGenerateLatis)
  },

  latisDispatchList: async function () {
    return await repository.resolveDatatable(this.nmInterfaceLatisDispatchList)
  },

  generate: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceGenerateLatis, params)
  },

  sendLatis: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceSendLatis, params)
  }
}
